import {Box, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {EventInfoType} from './type';

const EventInfo = ({
  title,
  subTitle,
  start,
  end,
  details,
  elimination,
}: EventInfoType) => {
  return (
    <Box
      p={{xxs: 1.5, md: 3}}
      border={`1px solid #84d2c1`}
      borderRadius={2}
      bgcolor="#e8fef9"
    >
      <Box
        bgcolor={'#49966e'}
        py={0.65}
        px={1.75}
        borderRadius={4}
        width={'fit-content'}
      >
        <Typography variant="subtitle2" color="white">
          {`${title} : ${subTitle}`}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: 3.5,
          alignItems: {xs: 'flex-start', md: 'center'},
          gap: {xs: 0, md: 10},
          flexDirection: {xs: 'column', md: 'row'},
        }}
      >
        <Box sx={{display: 'flex', marginTop: 3}}>
          <Image
            src={'https://static.iimjobs.com/epoch/static/assets/calendar.svg'}
            alt="calendar"
            height={24}
            width={24}
          />
          <Typography variant="body1">
            <Box component="span" sx={{marginLeft: '8px'}}>
              Start Date
            </Box>
            <br />

            <Box
              component="span"
              sx={{
                fontWeight: 600,
                color: 'primary.main',
                marginLeft: '8px',
              }}
            >
              {start}
            </Box>
          </Typography>
        </Box>
        <Box sx={{display: 'flex', marginTop: 3}}>
          <Image
            src={'https://static.iimjobs.com/epoch/static/assets/calendar.svg'}
            alt="calendar"
            height={24}
            width={24}
          />
          <Typography variant="body1">
            <Box component="span" sx={{marginLeft: '8px'}}>
              End Date
            </Box>
            <br />

            <Box
              component="span"
              sx={{
                fontWeight: 600,
                color: 'primary.main',
                marginLeft: 1,
              }}
            >
              {end}
            </Box>
          </Typography>
        </Box>
      </Box>

      <Box>
        <Typography typography={'subtitle1'} fontWeight="bold" color={'black'}>
          Round Details:
        </Typography>
        <Typography color={'black'}>{details}</Typography>
      </Box>
      {elimination && (
        <Typography
          typography={'subtitle1'}
          fontWeight="bold"
          color={'black'}
          sx={{
            mt: 2,
          }}
        >
          This is an elimination round.
        </Typography>
      )}
    </Box>
  );
};

export default EventInfo;
